import { contents } from ".."
import SkillItem from "../../components/SkillItem"

const SkingekiNoKyojin = () => {
    const filteredProjects = contents.filter((item) => item.slug === 'shingeki-no-kyojin-fan-game')
    const project = filteredProjects[0]

    return (
        <div className="overflow-hidden bg-white py-24 sm:py-32 rounded-md">
            <div className="mx-auto max-w-7xl px-6 lg:px-8">
                <div className="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 sm:gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-2">
                    <div className="lg:pr-8 lg:pt-4">
                        <div className="lg:max-w-lg">
                            <h2 className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">{project.title}</h2>
                            <div className="my-4">
                                {project.techStack.map((item, index: number) => {
                                    return (
                                        <SkillItem key={`landl-index-${index}-${item}`} label={item} />
                                    )
                                })}
                            </div>
                            <p className="mt-6 text-lg leading-8 text-gray-600 text-justify">
                            This is a fan game based on Attack on Titan (Shingeki No Kyojin). Players work together to fight titans.
                            <br />
                            <br />
                            I built the game with Unity3D and C#. It uses Photon for online play. Players use ODM gear to move around, fight titans, and protect the walls.
                            </p>
                            <br /><br />
                            <div>
                                <img
                                    src={require('../../assets/projects/shingeki-no-kyojin-fan-game/Youtube_stats.png')}
                                    alt="YouTube video stats"
                                    className="rounded-xl shadow-xl ring-1 ring-gray-400/10"
                                    width={2432}
                                    height={1442}
                                />
                            </div>
                            <br />
                            <div>
                            
                            </div>
                            <br />
                        </div>
                    </div>
                    <div className="lg:pt-4">
                        <iframe 
                            width="560" 
                            height="315"
                            src="https://www.youtube.com/embed/puf3t_Rr6R4?si=Gu17fW_pf_3wYQbo"
                            title="Shingeki No Kyojin fan game demo"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            referrerPolicy="strict-origin-when-cross-origin"
                            style={{
                                maxWidth: 560,
                                width: '100%',
                            }}
                            allowFullScreen></iframe>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SkingekiNoKyojin

